<template>
  <label
    class="switch-field"
    :class="{ 'switch-error': error,
     'disabled': disabled}"
  >
    <span class="switch-text">{{ label }}</span>

    <input
      :disabled="disabled"
      type="checkbox"
      :checked="modelValue"
      @change="onChange"
    />

    <span class="switch-slider"></span>

    <!-- Ant Tooltip -->
    <div
      v-if="tooltipText1"
      class="switch-tooltip-wrapper"
    >
      <a-tooltip
        placement="top"
        overlayClassName="custom-ant-tooltip"
      >
        <template #title>
          <div class="tooltip-content">
            <p class="tooltip-first">{{ tooltipText1 }}</p>

            <p
              v-if="tooltipText2"
              class="tooltip-second"
            >
              {{ tooltipText2 }}
            </p>

            <a
              v-if="tooltipLink"
              :href="tooltipLink"
              target="_blank"
              class="tooltip-link"
            >
              {{ tooltipLinkText || 'Подробнее' }}
            </a>
          </div>
        </template>

        <div class="switch-tooltip-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C10.9993 5.71733 10.9033 5.48 10.712 5.288C10.5207 5.096 10.2833 5 10 5C9.71667 5 9.47933 5.096 9.288 5.288C9.09667 5.48 9.00067 5.71733 9 6C8.99933 6.28267 9.09533 6.52033 9.288 6.713C9.48067 6.90567 9.718 7.00133 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88334 18.6867 3.825 17.9743 2.925 17.075C2.025 16.1757 1.31267 15.1173 0.788001 13.9C0.263335 12.6827 0.000667933 11.3827 1.26582e-06 10C-0.000665401 8.61733 0.262001 7.31733 0.788001 6.1C1.314 4.88267 2.02633 3.82433 2.925 2.925C3.82367 2.02567 4.882 1.31333 6.1 0.788C7.318 0.262667 8.618 0 10 0C11.382 0 12.682 0.262667 13.9 0.788C15.118 1.31333 16.1763 2.02567 17.075 2.925C17.9737 3.82433 18.6863 4.88267 19.213 6.1C19.7397 7.31733 20.002 8.61733 20 10C19.998 11.3827 19.7353 12.6827 19.212 13.9C18.6887 15.1173 17.9763 16.1757 17.075 17.075C16.1737 17.9743 15.1153 18.687 13.9 19.213C12.6847 19.739 11.3847 20.0013 10 20Z" fill="#A9A9A9" />
          </svg>
        </div>
      </a-tooltip>
    </div>

  </label>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

defineProps({
  label: { type: String, required: true },
  modelValue: { type: Boolean, required: true },
  error: { type: Boolean, default: false },

  tooltipText1: { type: String, default: '' },
  tooltipText2: { type: String, default: '' },

  tooltipLink: { type: String, default: '' },
  tooltipLinkText: { type: String, default: '' },
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(['update:modelValue'])

function onChange(e: Event) {
  const target = e.target as HTMLInputElement
  emit('update:modelValue', target.checked)
}
</script>

<style lang="scss">
.switch-field {
  position: relative;
  display: flex;
  border: 1px solid #e7eef5;
  border-radius: 20px;
  padding: 20px;
  align-items: center;
  width: 100%;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  background-color: #fff;
  transition: border-color 0.2s, background-color 0.2s;

  &:hover {
    border-color: #bbb;
  }

  @include mobile {
    width: calc(100% - 32px);
  }
}

.switch-field.disabled .switch-slider{
  opacity: 0.6;
  cursor: not-allowed;
}

.switch-field.switch-error {
  border-color: red;

  .switch-text {
    color: red;
  }
}

.switch-field input {
  display: none;
}

.switch-slider {
  width: 42px;
  height: 24px;
  background-color: #ccc;
  border-radius: 999px;
  position: relative;
  flex-shrink: 0;
  transition: background-color 0.2s;

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    transition: transform 0.2s;
  }
}

.switch-field input:checked + .switch-slider {
  background-color: #c8eb36;
}

.switch-field input:checked + .switch-slider::before {
  transform: translateX(18px);
}

.switch-text {
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: rgba(0, 0, 0, 0.85);
}

/* ---------------- Tooltip ---------------- */
.switch-tooltip-wrapper {
  position: absolute;
  left: calc(100% + 10px);
  top: 50%;
  transform: translateY(-50%);
}

.switch-tooltip-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a9a9a9;
  cursor: pointer;
}
</style>